var _path, _path2, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckContained(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 148,
    viewBox: "0 0 146 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.462 36.7566C105.457 30.1441 94.3401 26.2383 82.3115 26.2383C52.281 26.2383 27.9365 50.5828 27.9365 80.6133C27.9365 94.2966 32.9908 106.799 41.3343 116.357C27.8574 106.461 19.1094 90.5019 19.1094 72.5C19.1094 42.4695 43.4539 18.125 73.4844 18.125C89.8315 18.125 104.494 25.3387 114.462 36.7566Z",
    fill: "current",
    stroke: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4673 60.3139L66.6875 86.0938L57.8999 77.3061M73.4844 18.125C43.4539 18.125 19.1094 42.4695 19.1094 72.5C19.1094 102.53 43.4539 126.875 73.4844 126.875C103.515 126.875 127.859 102.53 127.859 72.5C127.859 42.4695 103.515 18.125 73.4844 18.125Z",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.9847,
    cy: 143.796,
    rx: 35.3578,
    ry: 4.20473,
    fill: "current",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckContained);
export default __webpack_public_path__ + "static/media/check-contained.d590dc12a4c5cc20e0a967dbc0f59234.svg";
export { ForwardRef as ReactComponent };